var exports = {
  "D": "BackToRepositorySelectionButton__IaHao0",
  "V": "alertNumberText__sN-w_u",
};

module.exports = exports;
